import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 dark:bg-slate-950 text-center p-6">
      <div>
        <div className="text-7xl font-bold bg-gradient-to-r from-brand-500 to-indigo-500 bg-clip-text text-transparent">404</div>
        <div className="text-xl font-semibold mt-2">Page not found</div>
        <p className="text-slate-500 mt-1">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn-primary mt-6 inline-flex">Go home</Link>
      </div>
    </div>
  );
}
